import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-chapter-main-quiz-start',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './quiz-start.component.html',
    styleUrls: ['./quiz-start.component.scss'],
    standalone: false
})
export class QuizStartComponent {
  typedRouteElements: { [id: string]: FlatModels.NodeEntityModels.RouteElement };

  constructor(public navigationControlFacade: FlatFacades.NavigationControlFacade,
              public trainingSharedFacade: FlatFacades.TrainingSharedFacade,
              public appSharedFacade: FlatFacades.AppSharedFacade,
              public nodeSharedFacade: FlatFacades.NodeSharedFacade,
              public alertControlFacade: FlatFacades.AlertControlFacade) {
    // Get Training Data
    this.nodeSharedFacade.currentSelectedSubjectNode$.pipe(takeUntilDestroyed()).subscribe(() => {
      this.trainingSharedFacade.requestTrainingNodesByCurrentSubject().subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
      });
    });
    
    // Update Typed Route Elements
    this.nodeSharedFacade.typedRouteElements$.pipe(takeUntilDestroyed()).subscribe((typedRouteElements) => {
      this.typedRouteElements = typedRouteElements;
    });
  }

  trackByChapter(index: number,
                 item: FlatModels.NodeEntityModels.NodeEntityType) {
    return item.id + item.position || index;
  }

  rowTrackBy(index: number,
             item: {id: string}) {
    return item.id
  }

  onRowSelect($event: any) {
    const routeElement = this.typedRouteElements[$event.data];
    this.navigationControlFacade.requestNavigate([routeElement.path]);
  }
}
